module.exports = __webpack_public_path__ + "img/icon_close.1bd38d29.svg";